/*jshint esversion: 6 */
/*jshint strict: false */

import './js/components/autocomplete';
// import '@fortawesome/fontawesome-free/js/solid';
// import './styles.scss';
// import './js/components/carousel';
import Alpine from "alpinejs";
import persist from "@alpinejs/persist"
import collapse from "@alpinejs/collapse"
import intersect from "@alpinejs/intersect";

// import Masonry from "masonry-layout";
// import {FocusedImage} from "image-focus";

// import './js/components/mouse-flowmap/index';


class ClassWatcher {

	constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
		this.targetNode = targetNode;
		this.classToWatch = classToWatch;
		this.classAddedCallback = classAddedCallback;
		this.classRemovedCallback = classRemovedCallback;
		this.observer = null;
		this.lastClassState = Array.from(targetNode.classList.values()).join().includes(classToWatch);
		if (this.lastClassState) {
			this.classAddedCallback();
		} else {
			this.classRemovedCallback();
		}

		this.init();
	}

	init() {
		this.observer = new MutationObserver(this.mutationCallback);
		this.observe();
	}

	observe() {
		this.observer.observe(this.targetNode, {attributes: true});
	}

	disconnect() {
		this.observer.disconnect();
	}

	mutationCallback = (mutationsList) => {
		for (let mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				let currentClassState = Array.from(mutation.target.classList.values()).join().includes(this.classToWatch);
				if (this.lastClassState !== currentClassState) {
					this.lastClassState = currentClassState;
					if (currentClassState) {
						this.classAddedCallback();
					} else {
						this.classRemovedCallback();
					}
				}
			}
		}
	}
}

document.addEventListener('alpine:init', () => {
	Alpine.data("toggle", () => ({
		open: false,
		blocked: true,
		trigger: {
			['@click']() {
				this.blocked = true;
				this.open = !this.open;
				this.$nextTick(() => this.blocked = false);
				if (this.$el.dataset.scrollToTop) {
					this.$nextTick(() => window.scrollTo(0, 0));
					window.scrollTo(0, 0);
				}
			},
			[':class']() {
				return this.open ? 'open' : 'close hover:open';
			}
		},
		dialogue: {
			[':class']() {
				return this.open ? 'open' : 'close hover:open';
			},
			['@click.outside']() {
				if (!this.blocked) {
					this.open = false;
				}
			},
		},
	}));
	Alpine.data("details", () => ({
		__open: false,
		__hover: false,
		__watch_hover: true,

		get isOpen() {
			return this.__open || (this.__watch_hover && this.__hover);
		},
		open() {
			this.__watch_hover = false;
			this.__open = true;
		},
		close() {
			this.__watch_hover = true;
			this.__open = false;
		},
		toggle() {
			this.__watch_hover = false;
			this.__open = !this.__open;
		},
		details: {
			['@click.outside']() {
				this.close();
			},
			[':open']() {
				return this.isOpen;
			},
			['@mouseleave']() {
				this.__hover = false;
				this.__watch_hover = true;
			}
		},
		summary: {
			['@click.prevent']() {
				this.toggle();
			},
			['@mouseover']() {
				this.__hover = false;
			}
		}
	}));
	Alpine.data("modal", () => ({
		__open: false,

		get isOpen() {
			return this.__open;
		},
		open() {
			this.__open = true;
		},
		close() {
			this.__open = false;
		},
		toggle() {
			this.__open = !this.__open;
		},
		dialog: {
			[':open']() {
				return this.isOpen;
			},
		},
		openTrigger: {
			['@click.prevent']() {
				this.open();
			},
		},
		closeTrigger: {
			['@click.prevent']() {
				this.close();
			},
		},
	}));
	Alpine.data("hideUnlessMarked", (parents = 1) => ({
		marked: [true],

		updateState() {
			if (this.marked.some(x => x)) {
				this.$root.classList.remove("hidden")
			} else {
				let strippedString = this.$root.innerText.replace(/(<([^>]+)>)/gi, "").trim();
				if (!strippedString) {
					this.$root.classList.add("hidden")
				}
			}
		},
		init() {
			let current = this.$root;
			for(let i = 0; i < parents; i++){
				let closest = current.closest("[data-__neos-node-contextpath]");
				new ClassWatcher(closest, "markActiveNodeAsFocused", () => {
					this.marked[i] = true;
					this.updateState()
				}, () => {
					this.marked[i] = false;
					this.updateState()
				});
				current = closest.parentElement;
			}
		}
	}));
});

Alpine.plugin(collapse)
Alpine.plugin(persist)
Alpine.plugin(intersect)
Alpine.start();
